import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { User } from '@/app-modules/store/modules/user';
import TombolaBaseComponent from '@/components/base/base.component';
import { ISweetAlertService } from '@/app-modules/sweet-alert-service';
import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';

@Component({
    name: 'SignOutComponent'
})
export default class SignOutComponent extends TombolaBaseComponent {
    private async signOut() {
        const userConfirmedSignOut = await this.showLogOutConfirmationToUser();
        if (userConfirmedSignOut) {
            this.removeUserDetailsFromStore();
            this.navigateLogin();
        }
    }

    private async showLogOutConfirmationToUser() {
        const {value: result} = await this.sweetAlertService.show({
            title: 'Log Out',
            text: 'Are you sure you wish to log out from ChatMods?',
            type: 'warning',
            allowOutsideClick: false,
            focusConfirm: false,
            showConfirmButton: true,
            showCancelButton: true
          }, true);
        return result;
    }

    private get sweetAlertService(): ISweetAlertService {
        return container.get(SERVICE_IDENTIFIERS.ISweetAlertService);
      }

    private removeUserDetailsFromStore() {
        this.$tombolaStore.Remove(User);
    }

    private navigateLogin() {
        this.$router.push('login');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/navigation-bar/_components/sign-out/sign-out.component.ts